import TsaAuthorizationCode from '@/components/authorizationCode/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const AuthorizationCode = vue.extend(TsaAuthorizationCode)
    if (!$vm) {
      $vm = new AuthorizationCode({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const authorizationCode = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaAuthorizationCode) {
      vue.prototype.$TsaAuthorizationCode = authorizationCode
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/authorizationCode/index.js